import { shop as SHOP_CONFIG } from "@/config";
import router from "@/router"; // 👈 додаємо

export const mutationTypes = {
  SET_PRODUCTS: "SET_PRODUCTS",
  SET_PRODUCT: "SET_PRODUCT",
  SET_CATEGORIES: "SET_CATEGORIES",
  SET_SORT_OPTION: "SET_SORT_OPTION",
  SET_FILTER_PARAMS: "SET_FILTER_PARAMS",
};

export default {
  namespaced: true,
  state: () => ({
    products: [],
    product: null,
    categories: [],
    sortOption: SHOP_CONFIG.SORT_OPTIONS.PRICE_ASC,
    filterParams: {
      categories: [],
      hasDiscount: false,
      priceFrom: null,
      priceTo: null,
    },
  }),
  getters: {
    products: (state) => state.products,
    product: (state) => state.product,
    categories: (state) => state.categories,
    sortOption: (state) => state.sortOption,
    filterParams: (state) => state.filterParams,

    isFiltersDirty: (state) => {
      const { categories, hasDiscount, priceFrom, priceTo } =
        state.filterParams;

      return (
        categories.length > 0 ||
        hasDiscount === true ||
        priceFrom !== null ||
        priceTo !== null
      );
    },

    availableProducts: (state) =>
      state.products.filter((p) => p.is_available && !p.is_hidden),

    availableCategories: (state, getters) => {
      const ids = getters.availableProducts.map((p) => p.category_id);
      return state.categories.filter((cat) => ids.includes(cat.id));
    },

    filteredAndSortedProducts: (state, getters) => {
      let result = [...getters.availableProducts];
      const f = state.filterParams;

      if (f.hasDiscount) {
        result = result.filter((p) => p.is_sale);
      }

      if (f.categories.length) {
        result = result.filter((p) => f.categories.includes(p.category_id));
      }

      if (f.priceFrom !== null) {
        result = result.filter((p) => p.price >= f.priceFrom);
      }

      if (f.priceTo !== null) {
        result = result.filter((p) => p.price <= f.priceTo);
      }

      switch (state.sortOption) {
        case "price_desc":
          return result.sort((a, b) => b.price - a.price);
        case "price_asc":
        default:
          return result.sort((a, b) => a.price - b.price);
      }
    },
  },
  mutations: {
    [mutationTypes.SET_PRODUCTS](state, payload) {
      state.products = payload;
    },
    [mutationTypes.SET_PRODUCT](state, payload) {
      state.product = payload;
    },
    [mutationTypes.SET_CATEGORIES](state, payload) {
      state.categories = payload;
    },
    [mutationTypes.SET_SORT_OPTION](state, payload) {
      state.sortOption = payload;

      const currentQuery = { ...router.currentRoute.value.query };
      router.replace({ query: { ...currentQuery, sort: payload } });
    },
    [mutationTypes.SET_FILTER_PARAMS](state, payload) {
      state.filterParams = payload;

      const currentQuery = { ...router.currentRoute.value.query };

      const newQuery = {
        ...currentQuery,
        categories: payload.categories?.join(",") || undefined,
        hasDiscount: payload.hasDiscount ? "1" : undefined,
        priceFrom: payload.priceFrom ?? undefined,
        priceTo: payload.priceTo ?? undefined,
      };

      router.replace({ query: newQuery });
    },
  },
};
